module.exports = __webpack_public_path__ + "static/readers_in_hand-crunch.536a0892.png";


//////////////////
// WEBPACK FOOTER
// ./src/sections/promos/signupHeader/images/readers_in_hand-crunch.png
// module id = 1701
// module chunks = 168707334958949